import { useCallback } from 'react';

import { AiAssistantNotifyMicrophoneCommand } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { interceptors } from '@dreryk/command-query-ws-client';
import { serialize } from '@dreryk/json-class-mapper-client';

import { AiAssistantMicrophoneEvent } from './useAiAssistantNotifyMicrophone';

const NOTIFY_MICROPHONE_COMMAND_URL = '/services/rest/cqrs/1.0/egabinet-ai-assistant-frontend-api/command';

export const useAiAssistantNotifyMicrophoneKeepalive = (): ((event: AiAssistantMicrophoneEvent) => void) => {
   return useCallback((event: AiAssistantMicrophoneEvent) => {
      const command = new AiAssistantNotifyMicrophoneCommand();
      command.event = event;

      const request = interceptors.handleRequest({
         body: serialize(command),
         credentials: 'include',
         headers: { 'Content-Type': 'application/json' },
         keepalive: true,
         method: 'POST',
      });

      fetch(NOTIFY_MICROPHONE_COMMAND_URL, request).catch(() => undefined);
   }, []);
};
